import { create } from "zustand";
import { persist } from "zustand/middleware";

type SidebarStatus = "opened" | "closed";

interface SidebarState {
  status: SidebarStatus;
  toggle: () => void;
  open: () => void;
  close: () => void;
}

export const useSidebarStore = create<SidebarState>()(
  persist(
    (set) => ({
      status: "opened",
      toggle: () =>
        set((state) => ({
          status: state.status === "opened" ? "closed" : "opened",
        })),
      open: () => set({ status: "opened" }),
      close: () => set({ status: "closed" }),
    }),
    {
      name: "sidebar-storage",
    }
  )
);
